import axios from 'axios';

export const ownerApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });
ownerApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem('po_token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const apiError = (e) => {
  const d = e.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map(x => x?.msg).filter(Boolean).join(' ');
  return 'Bir hata oluştu';
};

export const fmtDate = (d) => (d ? d.split('-').reverse().join('.') : '-');

export const daysLeft = (end, today) => (end && today ? Math.round((new Date(end) - new Date(today)) / 86400000) : null);

export const fmtBytes = (b) => {
  if (b >= 1024 ** 3) return `${(b / 1024 ** 3).toFixed(2)} GB`;
  if (b > 0 && b < 100 * 1024) return `${(b / 1024).toFixed(1)} KB`;
  return `${(b / 1024 ** 2).toFixed(1)} MB`;
};
